import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Url from "../global";
import "./Style/globalValidasiEror.scss";

const FormEditRiwayatPelatihan = () => {
  const [namaPelatihan, setNamaPelatihan] = useState("");
  const [tglMulai, setTglMulai] = useState("");
  const [tglSelesai, setTglSelesai] = useState("");
  const [noSertifikat, setNoSertifikat] = useState("");
  const [status, setStatus] = useState("");
  const [komentar, setKomentar] = useState("");
  const [penyelenggara, setPenyelenggara] = useState("");
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();
  const [file, setFile] = useState("");
  const [setError] = useState(null);
  const [setFileUrl] = useState("");
  const { id } = useParams();
  const { pegawai } = useSelector((state) => state.auth);

  const PdfViewer = ({ file }) => {
    return (
      <div>
        {file ? (
          <embed src={file} type="application/pdf" width="80%" height="600px" />
        ) : (
          <p>No PDF file uploaded</p>
        )}
      </div>
    );
  };

  const handleChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile && selectedFile.type === "application/pdf") {
      setFile(selectedFile);
      setFileUrl(URL.createObjectURL(selectedFile));
    } else {
      setFile(null);
      setError("File harus berupa PDF");
    }
  };

  useEffect(() => {
    const getRiwayatPelatihanById = async () => {
      try {
        const response = await axios.get(`${Url}/riwayat_pelatihans/${id}`);
        setNamaPelatihan(response.data.strNamaPelatihan);
        setTglMulai(response.data.dateTglMulai);
        setTglSelesai(response.data.dateTglSelesai);
        setNoSertifikat(response.data.strNoSertifikat);
        setStatus(response.data.strStatus);
        setPenyelenggara(response.data.strPenyelenggara);
        setKomentar(response.data.strKomentar);
        setFile(response.data.url);
      } catch (error) {
        if (error.response) {
          setMsg(error.response.data.msg);
        }
      }
    };
    getRiwayatPelatihanById();
  }, [id]);

  const updateRiwayatPelatihan = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("strNamaPelatihan", namaPelatihan);
      formData.append("dateTglMulai", tglMulai);
      formData.append("dateTglSelesai", tglSelesai);
      formData.append("strNoSertifikat", noSertifikat);
      formData.append("strStatus", status);
      formData.append("url", file);
      formData.append("strPenyelenggara", penyelenggara);
      formData.append("strKomentar", komentar);

      await axios.patch(`${Url}/riwayat_pelatihans/${id}`, formData, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      });
      navigate("/riwayat-pelatihan");
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };

  return (
    <div>
      <h1 className="title">Riwayat Platihan</h1>
      <h2 className="subtitle">Edit Riwayat Pelatihan</h2>

      <div className="card is-shadowless">
        <div className="card-content">
          <div className="content">
            <form className="box" onSubmit={updateRiwayatPelatihan}>
              <p className="has-text-centered">{msg}</p>
              <div className="field">
                <label className="label">Nama Pelatihan</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    placeholder="Nomor Ijazah"
                    value={namaPelatihan}
                    onChange={(e) => setNamaPelatihan(e.target.value)}
                  />
                </div>
              </div>

              <div className="field">
                <label className="label">Tanggal Mulai</label>
                <div className="control">
                  <Form.Group controlId="duedate" className="dtp">
                    <Form.Control
                      type="date"
                      name="duedate"
                      placeholder="Tanggal Mulai"
                      value={tglMulai}
                      onChange={(e) => setTglMulai(e.target.value)}
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="field">
                <label className="label">Tanggal Selesai</label>
                <div className="control">
                  <Form.Group controlId="duedate" className="dtp">
                    <Form.Control
                      type="date"
                      name="duedate"
                      placeholder="Tanggal Selesai"
                      value={tglSelesai}
                      onChange={(e) => setTglSelesai(e.target.value)}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="field">
                <label className="label">Nomor Sertifikat</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    placeholder="Tempat Sekolah"
                    value={noSertifikat}
                    onChange={(e) => setNoSertifikat(e.target.value)}
                  />
                </div>
              </div>
              <div className="field">
                <label className="label">Penyelenggara</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    placeholder="Penyelenggara"
                    value={penyelenggara}
                    onChange={(e) => setPenyelenggara(e.target.value)}
                  />
                </div>
              </div>

              <div className="field">
                <label className="label">Komentar</label>
                <div className="control">
                  {pegawai &&
                    (pegawai.strRole === "kabid kepegawaian" ||
                      pegawai.strRole === "admin") && (
                      <input
                        type="text"
                        className="input"
                        placeholder="Komentar"
                        value={komentar}
                        onChange={(e) => setKomentar(e.target.value)}
                      />
                    )}
                  {pegawai && pegawai.strRole === "user" && (
                    <input
                      type="text"
                      className="input"
                      placeholder="Komentar"
                      value={komentar}
                      onChange={(e) => setKomentar(e.target.value)}
                      disabled
                    />
                  )}
                </div>
              </div>

              <div className="field">
                <label className="label">Status Pelatihan</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    {pegawai &&
                      (pegawai.strRole === "kabid kepegawaian" ||
                        pegawai.strRole === "admin") && (
                        <select
                          className="dropdown"
                          value={status}
                          onChange={(e) => setStatus(e.target.value)}
                          required
                        >
                          <option>--Pilih--</option>
                          <option>Pengajuan Sertifikat Pelatihan</option>
                          <option>Disetujui Kabid Kepegawaian</option>
                          <option>Ditolak Kabid Kepegawaian</option>
                        </select>
                      )}

                    {pegawai && pegawai.strRole === "user" && (
                      <select
                        className="dropdown"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        required
                        disabled
                      >
                        <option>--Pilih--</option>
                        <option>Pengajuan Sertifikat Pelatihan</option>
                        <option>Disetujui Kabid Kepegawaian</option>
                        <option>Ditolak Kabid Kepegawaian</option>
                      </select>
                    )}
                  </div>
                </div>
              </div>

              <div className="field">
                <label className="label">Image</label>
                <div className="control">
                  <div className="file">
                    <label className="file-label">
                      <input
                        type="file"
                        accept="application/pdf"
                        onChange={handleChange}
                        name="file"
                      />
                      {/* <button type="submit">Upload</button> */}
                    </label>
                    {setError && <p className="error">{setError}</p>}
                  </div>
                  <br />
                  <PdfViewer file={file} />
                </div>
              </div>

          
              <br />
              <div className="field">
                <div className="control">
                  <button type="submit" className="button is-success">
                    Update
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormEditRiwayatPelatihan;
